"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ioTsUnionInterpreter = void 0;
var utils_1 = require("@morphic-ts/common/lib/utils");
var t = require("io-ts");
var hkt_1 = require("../hkt");
/**
 *  @since 0.0.1
 */
exports.ioTsUnionInterpreter = utils_1.memo(function () { return ({
    _F: hkt_1.IoTsURI,
    union: function (items) { return function (_guards, name) { return function (env) {
        return new hkt_1.IOTSType(t.union(items.map(function (x) { return x(env).type; }), name));
    }; }; } // TODO: fix (follow up: https://github.com/gcanti/io-ts/issues/312)
}); });
